import { ChainId } from '@plasma/plasmaswap-sdk';

export function parseChainId(chainId: string | number): ChainId {
  return (typeof chainId === 'number' ? chainId : parseInt(chainId, chainId.startsWith('0x') ? 16 : 10)) as ChainId;
}
